export const supportedLanguages = ['en', 'es', 'ru', 'uk'] as const;
export type SupportedLanguage = (typeof supportedLanguages)[number];
